import moment from "moment";

export default {
  methods: {
    parseDateReport(dateRange, typeTime) {
      try {
        let queryDate = []
        let typeFormat = typeTime == 'month' ? "YYYYMM" : "YYYYMMDD"
        queryDate.push(
          `{${typeTime}} >= ` +
            moment(dateRange.startDate).format(typeFormat) +
            ` and {${typeTime}} <= ` +
            moment(dateRange.endDate).format(typeFormat)
        );
  
        return queryDate.join("");
      } catch (error) {
        console.log(error);
      }
    }
  }
}